import { useContext, useEffect } from "react";
import { FaDiscord } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { Context } from "../Context";
import { useNavigate } from "react-router-dom";

function Footer() {
  const context = useContext(Context);
  const fishcordServerInviteURL = context.urls.fishcordServerInviteURL;
  const year = new Date().getFullYear();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <footer id="footer">
      <div className="flex flex-col w-4/5 m-auto pb-12 items-center">
        <p className="text-md font-medium mb-2">Join the Fishcord Community</p>
        <div className="flex mb-1">
          <p className="text-md flex items-center mr-8">
            Follow us on
            <FaXTwitter className="ml-1 text-xl hover:opacity-70 hover:cursor-pointer" />
          </p>
          <p className="text-md flex items-center">
            Join our
            <a href={fishcordServerInviteURL} target="_blank" rel="noopener noreferrer">
              <FaDiscord className="ml-1 text-2xl hover:opacity-70" />
            </a>
          </p>
        </div>
        <div className="flex mb-2">
          <p className="text-md mr-8 hover:opacity-70 hover:cursor-pointer" onClick={() => navigate('/terms-of-service')}>
            Terms of Service
          </p>
          <p className="text-md hover:opacity-70 hover:cursor-pointer" onClick={() => navigate('/privacy-policy')}>
            Privacy Policy
          </p>
        </div>
        <p className="text-md">© {year} Fishcord. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
